import { MedplumClient } from '@medplum/core';
import { createComponentLogger } from '@/lib/utils/logger';

const logger = createComponentLogger('medplumApi');

// NOTE: This file is being phased out in favor of direct API calls via apiClient
// The getMedplumClient is kept for legacy functions that haven't been migrated yet
const AUTH_API_BASE_URL = import.meta.env.VITE_AUTH_API_URL;
// IMPORTANT: MedplumClient adds /fhir/R4 automatically, so baseUrl should NOT include it
const MEDPLUM_BASE_URL = `${AUTH_API_BASE_URL}/api/hmis`;

/**
 * Initialize Medplum Client
 *
 * @deprecated This client is being phased out. Use apiClient from './client.ts' instead.
 * Only kept for legacy functions that haven't been migrated yet.
 */
let medplumClientInstance: MedplumClient | null = null;

export function getMedplumClient(): MedplumClient {
  if (!medplumClientInstance) {
    logger.log('⚠️ Initializing legacy Medplum Client - consider migrating to apiClient');
    logger.log('Medplum Base URL (will add /fhir/R4 automatically):', MEDPLUM_BASE_URL);

    medplumClientInstance = new MedplumClient({
      baseUrl: MEDPLUM_BASE_URL,
      // No clientId needed for JWT Bearer token authentication
      // Storage is optional - will use localStorage by default
      onUnauthenticated: () => {
        logger.warn('Medplum client unauthenticated');
      },
    });
  }
  return medplumClientInstance;
}

export function initializeMedplumClient(): MedplumClient {
  return getMedplumClient();
}

export function isMedplumAuthenticated(): boolean {
  try {
    const client = getMedplumClient();
    return client.isAuthenticated();
  } catch (error) {
    logger.error('Error checking Medplum authentication:', error);
    return false;
  }
}

export function getMedplumAccessToken(): string | undefined {
  try {
    const client = getMedplumClient();
    return client.getAccessToken();
  } catch (error) {
    logger.error('Error getting Medplum access token:', error);
    return undefined;
  }
}

export async function medplumLogout(): Promise<void> {
  try {
    const client = getMedplumClient();
    await client.signOut();
    logger.log('Medplum logout successful');
  } catch (error) {
    logger.error('Error during Medplum logout:', error);
  }
}
